import styled from '@emotion/styled'

const StepContainer = styled('div')((props) => {
  return({
  display: 'grid',
  gridTemplateColumns: props?.columns ? props.columns : '1fr 1fr 1fr',
  gridTemplateRows: '1fr',
  gridGap: '1rem 1rem',
  width: '100%',
  justifyItems: 'center',
  height: 'auto',
  [props.theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    display: 'flex',
    flexDirection: 'column'
  },
  [props.theme.breakpoints.down('xs')]: {
    width: 'auto',
  }
})});

export default StepContainer
